// 银行主数据国际化配置文件
export default {
  bank: {
    label: {
      bankCode: '银行代码',
      brankName: '分行名称',
      bankName: '银行名称',
      bankUnionNumber: '银行联行号',
      swiftCode: 'SWIFT码',
      bankNational: '银行国家',
      bankRegion: '地区',
      bankStreet: '街道',
      bankCity: '城市',
      branch: '分行',
      bankGroup: '银行组',
      bankStatus: '状态',
    },
    buttons: {
      forbid: '禁用',
      enable: '启用',
      import: '导入',
    },
    message: {
      noSelected: '您还未选择任何数据',
      oneFile: '请上传单个文件',
      importError: '文件导入失败',
      importSuccess: '文件导入成功',
      overSvae: '已生效',
      reject: '已禁用',
    },
  },
};
